import { PotentialExceptionsParams } from "PFCore/services/audit_planner";

export const potentialExceptionsKeys = {
  all: () => ["potentialExceptions"],
  withParameters: (params: PotentialExceptionsParams) => [...potentialExceptionsKeys.all(), params]
};
